"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "asso": {
    "faa730e9": [{
      "hkey": "4104bb48",
      "slug": "canova",
      "name": "Canova",
      "primary": true,
      "skipSearch": false
    }],
    "ca-nova": [{
      "hkey": "4104bb48",
      "slug": "canova",
      "name": "Canova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b156fbcd": [{
      "hkey": "7474a94f",
      "slug": "asso",
      "name": "Asso",
      "primary": true,
      "skipSearch": false
    }],
    "fraino": [{
      "hkey": "7474a94f",
      "slug": "asso",
      "name": "Asso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09bf1f0b": [{
      "hkey": "7474a94f",
      "slug": "asso",
      "name": "Asso",
      "primary": true,
      "skipSearch": false
    }],
    "gallegno": [{
      "hkey": "7474a94f",
      "slug": "asso",
      "name": "Asso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;